/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .contact-container[_ngcontent-%COMP%]{min-height:500px;position:relative}[_nghost-%COMP%]   .no-contacts[_ngcontent-%COMP%]{text-align:center;font-size:1.5rem}[_nghost-%COMP%]   h2[_ngcontent-%COMP%]{margin-left:6px}"];
export { styles as styles };
